import { Tooltip } from 'yoc-ui-library';

import { classesBuilder } from '@common/helpers';

import { useLanguageSwitch } from './hooks';
import type { ILanguageSwitchProps } from './types';

import styles from './styles.module.scss';

const LanguageSwitch = ({ theme }: ILanguageSwitchProps) => {
  const { language, changeLanguage, languages, disabledLanguages } = useLanguageSwitch();

  return (
    <div className={classesBuilder(styles.wrapper, styles[theme])}>
      {languages.map((lang) => {
        const isDisabled = disabledLanguages.includes(lang);
        const button = (
          <button
            key={lang}
            type="button"
            onClick={() => {
              return changeLanguage(lang);
            }}
            className={classesBuilder(styles.option, {
              [styles.active]: language === lang,
              [styles.disabled]: isDisabled,
            })}
            aria-pressed={language === lang}
            aria-disabled={isDisabled}
          >
            {lang}
          </button>
        );

        if (!isDisabled) {
          return button;
        }

        return (
          <Tooltip
            key={lang}
            title="Coming Soon"
            trigger={['hover', 'click']}
          >
            {button}
          </Tooltip>
        );
      })}
    </div>
  );
};

export default LanguageSwitch;
